import Navbar from "./components/Navbar"
import SearchPanal from "./components/SearchPanal";
import SearchZone from "./components/SearchZone"

function App() {
  return (
    <div className="App">
      <Navbar />
      <SearchZone />
      <SearchPanal />
    </div>
  );
}

export default App;
